import sharedConstants from "@lib/shared_constants.json";

export const getEventName = (jobToken: string) =>
  `${sharedConstants.REALTIME_NOTIFIER.event.async_result_event_prefix}${jobToken}`;
